import React from 'react';
import { Link as RouterLink } from 'react-router';
import styles from './AppNavContent.module.scss';

const AppNavContent: React.FC = () => (
  <nav aria-label="Main navigation" className={styles.navLinks}>
    <RouterLink to="/search" className={styles.navLink}>
      Search Strings
    </RouterLink>
    <RouterLink to="/trackMyTranslations" className={styles.navLink}>
      Track Translations
    </RouterLink>
  </nav>
);

export default AppNavContent;
